import { requestGet } from '@/common/request';

export interface listAllChannelTreeParams {
  type?: number;
}

export interface listAllChannelTreeRes {
  ret: string;
  msg: string;
  data: {
    list:
      | Array<{
          id: number;
          channelId: string;
          name: string;
          pic: string;
          order: string;
          remark: string;
          linkType: string;
          link: string;
          online: string;
          channelLevel: string;
          childChannelCount: string;
          channelType: string;
          elseTowerIds: string;
          nativePageId: string;
          channelSeparation: number;
          children:
            | Array<{
                id: number;
                channelId: string;
                name: string;
                pic: string;
                order: string;
                remark: string;
                linkType: string;
                link: string;
                online: string;
                channelLevel: string;
                childChannelCount: string;
                channelType: string;
                childChannelList:
                  | Array<{
                      id: number;
                      channelId: string;
                      name: string;
                      pic: string;
                      order: string;
                      remark: string;
                      linkType: string;
                      link: string;
                      online: string;
                      channelLevel: string;
                      childChannelCount: string;
                      channelType: string;
                    }>
                  | [];
              }>
            | [];
        }>
      | [];
  };
}

//查询频道tree-客户端
export async function listAllChannelTree(params: listAllChannelTreeParams): Promise<listAllChannelTreeRes> {
  return await requestGet('/channelActivity/listAllChannelTree', params);
}
